import TagManager from 'react-gtm-module/dist/TagManager';
import axios from 'axios';

export default class GTMTracking {
    trackingID = process.env.VITE_GTM_TRACKING_ID;
    tagManagerArgs = {
        gtmId: this.trackingID,
        dataLayer: {
            userId: '001',
            userProject: 'customerArea',
        },
    };
    cookieName = window.$cookieName;
    isInit = false;

    constructor() {
        TagManager.initialize(this.tagManagerArgs);
    }

    initializeGTM() {
        this.gtag('consent', 'default', {
            analytics_storage: 'denied',
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            wait_for_update: 500,
        });
    }

    createRandomKey(length) {
        // call : makeRandomKey(36).match(/.{1,6}/g).join('-')
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result.match(/.{1,6}/g).join('-');
    }

    setCookie(consent, location) {
        const userId = this.createRandomKey(36);
        const consentMode = {
            // statistik cookies
            analytics_storage: consent.analytics_storage ? 'granted' : 'denied',
            // marketing
            ad_storage: consent.ad_storage ? 'granted' : 'denied',
            // werbung
            ad_user_data: consent.ad_user_data ? 'granted' : 'denied',
            // personalisierte
            ad_personalization: consent.ad_personalization ? 'granted' : 'denied',
        };
        const consentUrl = window.$baseUrl + location?.pathname;
        const cookieValue = {
            stamp: userId,
            necessary: true,
            ver: '1',
            utc: Date.now(),
            region: 'de',
            consentUrl: consentUrl,
            ...consentMode,
        };
        const expiresDate = new Date();
        expiresDate.setTime(expiresDate.getTime() + 63072000000); // two years in milliseconds

        document.cookie =
            this.cookieName +
            '=' +
            JSON.stringify(cookieValue) +
            ';expires=' +
            expiresDate.toUTCString() +
            ';path=/;secure;SameSite=Strict';
        this.saveData(userId, consentMode, consentUrl);
    }

    saveData(uuid, consent, location) {
        const params = {
            uuid: uuid,
            source: 'customerarea',
            consentUrl: location,
            userAgent: window.navigator.userAgent,
            acceptedServices: ['essential'],
        };

        Object.keys(consent).forEach((item) => {
            if (consent[item] === 'granted') {
                params.acceptedServices.push(item);
            }
        });

        axios({
            url: window.$website + '/CookieUser/saveDataFromRequest?token=' + window.$token,
            method: 'POST',
            data: params,
        })
            .then((response) => response)
            .then((response) => {
                if (response.statusText === 'OK') {
                    this.gtag('consent', 'update', consent);
                }
            })
            .catch((e) => {
                console.log('Error: ', e);
            });
    }

    getCookie(name) {
        const cookieData = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (cookieData) {
            return JSON.parse(cookieData[2]);
        } else {
            return null;
        }
    }

    gtag(props) {
        window.dataLayer.push(arguments);
    }
}
